<template>
  <div class="page-wrapper">
    <div class="page-breadcrumb sticky-breadcrumb">
      <div class="row">
        <div class="col-md-5 align-self-center col-sm-4 col-12">
          <ul class="breadcrumb mb-2 list-style-none">
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link class="mylink" :to="'/users/all-users'">{{
                $t("all-users")
              }}</router-link>
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
              v-if="canPerformAction('users', 'addOrEdit')"
            >
              <router-link class="mylink" :to="'/users/permissions'">{{
                $t("permissions")
              }}</router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-7" v-if="this.$route.name === 'Users'">
          <div class="d-flex align-items-center justify-content-end">
            <a
              class="btn btn-secondary mr-2"
              @click.prevent="exportRecord"
              href="javascript:void(0)"
              v-if="canPerformAction('users', 'export')"
            >
              {{ $t("exp-csv") }}
            </a>
            <button
              data-step="1"
              data-intro="<h5 style='margin-bottom: 1rem; color: #213e7a'>Users</h5>Assign members of your team to monitor selected devices."
              @click="addUserModal = true"
              class="btn btn-primary"
              v-if="canPerformAction('users', 'addOrEdit')"
            >
              {{ $t("add_user") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <router-view
      :addUserModal="addUserModal"
      @closeAddUserModal="addUserModal = false"
    />

    <footer class="footer text-center">
      &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ViewUsers",
  computed: {
    ...mapGetters(["users", "profile", "usersMeta"]),
    canPerformAction() {
      return this.$store.getters.canPerformAction;
    },
  },
  data() {
    return {
      addUserModal: false,
    };
  },
  methods: {
    exportRecord() {
      if (this.users.length == 0) {
        return null;
      }
      var head = [[this.$t("name"), this.$t("email"), this.$t("user_rights")]];
      var body = [];

      let length = this.users.length;
      for (let i = 0; i < length; i++) {
        body.push([
          this.users[i].fullname,
          this.users[i].email,
          this.users[i].role,
        ]);
      }
      body.unshift(head);
      body = body.map((e) => e.join(",")).join("\n");
      let csvContent = "data:text/csv;charset=utf-8," + body;
      csvContent = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", csvContent);
      link.setAttribute("download", `users.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
  },
};
</script>

<style>
.mylink {
  color: #213e7a !important;
  font-size: 14px !important;
  text-decoration-color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #213e7a !important;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
  text-underline-offset: 5px;
}
</style>
